import httpService from "services/api.service";

const BASE_URL = "/check-in-sales";

export const getAbsensi = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.message;
  }
};
